import {ReactNode} from "react";
import {useParams} from "react-router";

export const Redirect = ({url}: {url: string}): ReactNode => {
  window.location.replace(url);
  return null;
};

interface RedirectWithParamProps {
  urlPattern: string; // statuspages/:id/manage <- id to be replaced
  paramName: string; // "id"
}

export const RedirectWithParam = ({urlPattern, paramName}: RedirectWithParamProps) => {
  const paramValue = useParams()[paramName]!;
  return <Redirect url={urlPattern.replace(`:${paramName}`, paramValue)} />;
};
